// Shared shape for the per-user progress snapshot stored on showBuddies docs.
// Server-only (used by the buddy API routes with the Admin SDK).

export interface BuddyProgressSnapshot {
  watchedSeasons: number[];
  episodesWatched: number;
  lastEpisode: string | null; // "S2E5"
  totalSeasons: number;
  updatedAt: string;
}

export function buildProgressSnapshot(watchlistItem: any): BuddyProgressSnapshot {
  const watchedEpisodes: Record<string, number[]> = watchlistItem?.watchedEpisodes || {};

  let episodesWatched = 0;
  let lastEpisode: string | null = null;
  let bestSeason = -1;
  let bestEpisode = -1;

  for (const [seasonStr, episodes] of Object.entries(watchedEpisodes)) {
    const season = parseInt(seasonStr, 10);
    const eps = episodes || [];
    episodesWatched += eps.length;
    for (const ep of eps) {
      if (season > bestSeason || (season === bestSeason && ep > bestEpisode)) {
        bestSeason = season;
        bestEpisode = ep;
      }
    }
  }

  if (bestSeason > 0) {
    lastEpisode = `S${bestSeason}E${bestEpisode}`;
  }

  return {
    watchedSeasons: watchlistItem?.watchedSeasons || [],
    episodesWatched,
    lastEpisode,
    totalSeasons: watchlistItem?.totalSeasons || 0,
    updatedAt: new Date().toISOString(),
  };
}
